import React, { createContext, useContext, useEffect, useState } from 'react';

const InternetStatusContext = createContext();

export const useInternetStatus = () => {
  const context = useContext(InternetStatusContext);
  if (!context) {
    throw new Error('useInternetStatus must be used within an InternetStatusProvider');
  }
  return context;
};

export const InternetStatusProvider = ({ children }) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showStatus, setShowStatus] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowStatus(true);
      // Hide status after 3 seconds
      setTimeout(() => setShowStatus(false), 3000);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowStatus(true);
    };

    // Add event listeners
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Cleanup
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const value = {
    isOnline,
    showStatus,
    hideStatus: () => setShowStatus(false)
  };

  return (
    <InternetStatusContext.Provider value={value}>
      {children}
    </InternetStatusContext.Provider>
  );
};